module.exports = __webpack_public_path__ + "img/counter.6ae845e2.svg";